/**
 * Pestañas de la pantalla "Integración" (009 · T029 · F6; contracts/ui.md §1).
 *
 * `INTEGRATION_TAB_IDS` es el catálogo de la URL (`?tab=conexion|sincronizar|revision|historial`)
 * que usa `routes/_app/integracion.tsx` en `validateSearch`. Sin `tab` en la URL, la pantalla abre
 * `conexion` si no hay una conexión verificada y `sincronizar` si la hay.
 *
 * Vive aparte de `integration-page.tsx` para que las pestañas de cada historia importen
 * `IntegrationTabProps` sin ciclo de imports.
 */
import type { IntegrationOverviewResponse } from '@fermin/contracts';

export const INTEGRATION_TAB_IDS = ['conexion', 'sincronizar', 'revision', 'historial'] as const;
export type IntegrationTab = (typeof INTEGRATION_TAB_IDS)[number];

/** `true` si el valor es una pestaña del catálogo. */
export function isIntegrationTab(value: unknown): value is IntegrationTab {
  return typeof value === 'string' && (INTEGRATION_TAB_IDS as readonly string[]).includes(value);
}

/** Pestaña por defecto: `conexion` sin conexión verificada; si no, `sincronizar`. */
export function defaultIntegrationTab(
  overview: IntegrationOverviewResponse | undefined,
): IntegrationTab {
  return overview?.integration?.verified ? 'sincronizar' : 'conexion';
}

/** Props que recibe cada pestaña (y cada sección bajo ella). */
export interface IntegrationTabProps {
  /** Vista general (I1) ya cargada; se sondea mientras hay una ejecución en curso. */
  overview: IntegrationOverviewResponse;
  /** Cambia de pestaña (p. ej. "Probar conexión" → "Sincronizar"). */
  onNavigate: (tab: IntegrationTab) => void;
}
